module.exports = __webpack_public_path__ + "img/guide7.c589c8fe.jpg";